<template>
  <div id="profile-achievements" data-tourid="profile-sheet-achievements">
    <p class="text-subtitle-2 font-weight-bold mb-4">
      {{ $t('profile.achievements') }}
    </p>
    <div class="d-flex align-start flex-wrap" v-if="!isLoading">
      <v-card outlined class="rounded px-4 py-3 mb-2 flex-grow-1">
        <div class="d-flex justify-space-between">
          <p
            class="text-h5 ma-0 pa-0 font-weight-bold blue-grey--text text--darken-3"
          >
            {{ completedRevs }}
          </p>
          <div
            class="d-flex align-center justify-center icon-wrapper"
            style="background-color: #E3FADB"
          >
            <v-icon color="green" size="16">mdi-check-circle-outline</v-icon>
          </div>
        </div>
        <p
          class="text-body-2 blue-grey--text text--darken-2 ma-0 pa-0"
          v-snip="2"
        >
          {{ $t('profile.completed_revs') }}
        </p>
      </v-card>
      <v-card outlined class="rounded px-4 py-3 mb-2 flex-grow-1">
        <div class="d-flex justify-space-between">
          <p
            class="text-h5 ma-0 pa-0 font-weight-bold blue-grey--text text--darken-3"
          >
            {{ highlightedRevs }}
          </p>
          <div
            class="d-flex align-center justify-center icon-wrapper"
            style="background-color: #FFF3D6"
          >
            <v-icon color="yellow" size="16">mdi-star-outline</v-icon>
          </div>
        </div>
        <p
          class="text-body-2 blue-grey--text text--darken-2 ma-0 pa-0"
          v-snip="2"
        >
          {{ $t('profile.highlighted_revs') }}
        </p>
      </v-card>
      <v-card outlined class="rounded px-4 py-3 flex-grow-1">
        <div class="d-flex justify-space-between">
          <p
            class="text-h5 ma-0 pa-0 font-weight-bold blue-grey--text text--darken-3"
          >
            {{ inProgressRevs }}
          </p>
          <div
            class="d-flex align-center justify-center icon-wrapper"
            style="background-color: #E7F0FD"
          >
            <v-icon color="blue" size="16">mdi-progress-check</v-icon>
          </div>
        </div>
        <p
          class="text-body-2 blue-grey--text text--darken-2 ma-0 pa-0"
          v-snip="2"
        >
          {{ $t('profile.revs_in_progress') }}
        </p>
      </v-card>
    </div>

    <div v-else>
      <v-card outlined class="px-4 py-3 me-2" height="86">
        <v-skeleton-loader type="text" class="mb-2" width="25" />
        <v-skeleton-loader type="text" />
      </v-card>
      <v-card outlined class="px-4 py-3 me-2 mt-2" height="86">
        <v-skeleton-loader type="text" class="mb-2" width="25" />
        <v-skeleton-loader type="text" />
      </v-card>
      <v-card outlined class="px-4 py-3 mt-2" height="86">
        <v-skeleton-loader type="text" class="mb-2" width="25" />
        <v-skeleton-loader type="text" />
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Achievements',

  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },
    stats: {
      required: true,
      type: Object,
    },
  },

  computed: {
    completedRevs() {
      return this.stats?.completedRevs ?? 0
    },

    highlightedRevs() {
      return this.stats?.highlightedRevs ?? 0
    },

    inProgressRevs() {
      return this.stats?.inProgressRevs ?? 0
    },
  },
}
</script>
<style lang="scss" scoped>
.icon-wrapper {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: $color-blue-grey-lighten2;
}
</style>
